import type { Component } from 'vue';
import AppLayout from '@/layouts/AppLayout.vue';
import OrgLayout from '@/layouts/OrgLayout.vue';
import OrgAuthLayout from '@/layouts/OrgAuthLayout.vue';
import BlogLayout from '@/layouts/BlogLayout.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import SettingsLayout from '@/layouts/settings/Layout.vue';

export const appName = import.meta.env.VITE_APP_NAME || 'LaunchStation';

/**
 * Document title callback shared by the client and server Inertia entries.
 */
export function pageTitle(title: string): string {
    return title ? `${title} - ${appName}` : appName;
}

/**
 * Resolve the layout stack for a page name. Shared by the client (app.ts) and
 * the server (ssr.ts) entries so both render the same layout tree.
 */
export function resolveLayout(name: string): Component | Component[] | null {
    switch (true) {
        case name.startsWith('org/auth/'):
            return OrgAuthLayout;
        case name.startsWith('org/'):
        case name.startsWith('blog/admin/'):
            return OrgLayout;
        case name === 'blog/Index':
        case name === 'blog/Show':
            return BlogLayout;
        case name === 'Welcome':
        case name.startsWith('marketing/'):
            return null;
        case name.startsWith('auth/'):
            return AuthLayout;
        case name.startsWith('settings/'):
        case name.startsWith('teams/'):
            return [AppLayout, SettingsLayout];
        default:
            return AppLayout;
    }
}
